import { clientConfig } from '@/config/client';

const { subscriptionHost = '' } = clientConfig;

export const getGiftUrl = (language: string): string =>
    `${subscriptionHost}/${language}/gift?utmSource=allplay&promoName=allplay`;
